import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import * as reviewsActions from '../../actions/reviewsActionCreators';
import {withRouter} from 'react-router-dom';
import Layout from '../../layout/Layout';
import {NavLink} from 'react-router-dom';
import {useMount} from 'react-use';
import ReviewsList from '../../components/Reviews/List';
import SeoTags from '../../routes/SeoTags';
import ReviewsStats from '../../components/Reviews/Stats';
import './style.scss';
import './mobile.scss';
import constants from '../../constants';

const ReviewsPage = (props) => {
  const
    {site_collection} = props.reviewsState,
    paginator = {
      ...props.reviewsState.paginator,
      onChange: (page, per_page) => {
        props.reviewsActions.fetchReviews({
          page,
          per_page
        });
      }
    };

  useMount(() => {
    props.reviewsActions.fetchReviews();
    props.reviewsActions.fetchReviewsStats();
  });

  return (
    <Layout
      className='reviews-page'
      breadcrumbs={[
        {label: 'Отзывы'}
      ]}
    >
      <SeoTags
        controller_action='reviews#index'
      />

      <div className='container'>
        <div className='reviews-page__navigation'>
          <NavLink className='link' to={constants.ROUTES.REVIEWS_PATH}>Отзывы</NavLink>
          <NavLink className='link' to={constants.ROUTES.PARTNERS_PATH}>Партнёры</NavLink>
        </div>
        <div className='reviews-page__container'>
          <div className='reviews-page__left-col'>
            <ReviewsList
              full
              reviews={site_collection}
              paginator={paginator}
            />
          </div>
          <div className='reviews-page__right-col'>
            <ReviewsStats average={props.reviewsState.average} stats={props.reviewsState.stats}/>
          </div>
        </div>
      </div>
    </Layout>
  );
}

const mapDispatchToProps = (dispatch) => {
    return {
      reviewsActions: bindActionCreators(reviewsActions, dispatch)
    };
  },

  mapStateToProps = ({reviewsState, railsContext, applicationState}) => {
    return {
      applicationState,
      reviewsState,
      railsContext
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default withRouter(compose(withConnect)(ReviewsPage));
